import React, { useCallback, useContext } from 'react';
import { TreemapWidget } from './index';
import { NonIdealState } from '@blueprintjs/core';
import { TREE_MAP_GROUP_BY_KEY } from 'widgets/treemap/knobs';
import { WorkspaceActionCreator } from 'hooks/useWorkspaceState';
import { WorkspaceContext } from 'views/workspace/workspaceContext';
import { NO_DATA_MESSAGE } from 'widgets/chartUtils';

/**
 * ChartWrapper for the Test Widget.
 *
 * FIXME: Currently does that thing where it won't allow the parent to shrink.
 *
 * @param widgetConfiguration
 * @param dimensions
 * @param data
 * @param noDataMessage
 * @returns {*}
 * @constructor
 */
export function TreemapWrapper({ widgetConfiguration = {}, dimensions, data, noDataMessage=NO_DATA_MESSAGE, endpointQuery, cardIndex }) {

	const { dispatch } = useContext(WorkspaceContext);

	const treemapProperty = endpointQuery?.options?.propertyList?.[TREE_MAP_GROUP_BY_KEY];
	const { focusedNodeKey } = widgetConfiguration;


	const setFocusedNode = useCallback((focusedNodeKey) => {
		dispatch(WorkspaceActionCreator.configuration(cardIndex, { focusedNodeKey }));
	}, [cardIndex, dispatch]);

	return data?.count > 0 ? (
		<TreemapWidget
			data={data}
			dimensions={dimensions}
			treemapProperty={treemapProperty}
			focusedNodeKey={focusedNodeKey}
			setFocusedNode={setFocusedNode}
		/>
	) : (
		<NonIdealState
			title="No Data Found"
			icon="graph-remove"
			description={noDataMessage}
		/>
	);
}
